import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Switch, Typography } from '@material-ui/core';
import ShankCard from './ShankCard';

const useStyles = makeStyles((theme) => ({
  sizeCard: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    width: '100%',
    minWidth: '450px',
    maxWidth: '625px',
  },
  sizeHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  sizeName: {
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  shanksContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: theme.spacing(2),
  },
  disabled: {
    opacity: 0.5,
    pointerEvents: 'none',
  },
}));

const ShapeSizeCard = ({ 
  size, 
  sizeConfig, 
  shape, 
  shapeEnabled, 
  onSizeToggle,
  onShankToggle,
  onScaleChange, 
  onPaddingChange,
  onShadowChange,
  onRotationChange 
}) => {
  const classes = useStyles();
  return (
    <div className={`${classes.sizeCard} ${!shapeEnabled ? classes.disabled : ''}`}>
      <div className={classes.sizeHeader}>
        <Switch
          checked={size.checked}
          onChange={(e) => onSizeToggle(shape?.id, size.id, e.target.checked)}
          color="primary"
          disabled={!shapeEnabled}
        />
        <Typography className={classes.sizeName}>{size.name}</Typography>
      </div>

      <div className={classes.shanksContainer}>
        {size?.children?.map((shank) => {
          const shankConfig = sizeConfig?.shanks?.find(s => s.shank_sku === shank.sku);
          
          return (
            <ShankCard 
              key={shank.id}
              size={size}
              shape={shape}
              shapeEnabled={shapeEnabled}
              sizeConfig={sizeConfig}
              shank={shank}
              shankConfig={shankConfig}
              onShankToggle={onShankToggle}
              onScaleChange={onScaleChange}
              onPaddingChange={onPaddingChange}
              onShadowChange={onShadowChange}
              onRotationChange={onRotationChange}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ShapeSizeCard;
